import React, { useEffect, useState } from 'react'
import { Button, Spinner } from 'react-bootstrap';
import useUtenti from '../../../hooks/useUtenti';
import useAgenzie from '../../../hooks/useAgenzie';

const UpdateUserPendingForm = ({setFormDataUpdateUserPending, formDataUpdateUserPending, onUndoChanges, userData, printAllUtenti}) => {
   const {updateUtente, loadingStateUtenti} = useUtenti();
   const { getAllAgenzie } = useAgenzie();
   const [agenzie, setAgenzie] = useState([]);

  useEffect(() => {
    if(userData) {
      setFormDataUpdateUserPending(userData)
    }
  }, [userData])

  useEffect(() => {
    const fetchAgenzie = async () => {
      try {
        const response = await getAllAgenzie();
        setAgenzie(response || []);
      } catch (error) {
        console.error('Errore nel recupero delle agenzie:', error);
      }
    };
    fetchAgenzie();
  }, [])
  
  const handleFormChange = e => {
    const { name, value } = e.target;
    setFormDataUpdateUserPending(prevState => ({ ...prevState, [name]: value }));
  }

  const onUpdateUserPending = async () => {
    const res = await updateUtente(formDataUpdateUserPending);
    if(res) {
      onUndoChanges()
      printAllUtenti()
    }
  }

  return (
    <div className='row'>
        <div className='col-sm-12 my-2'>
          <span className='small text-muted d-block'><b>Nome</b></span>
          <input name="nome" value={formDataUpdateUserPending?.nome || ''} onChange={handleFormChange} className="form-control" type="text" placeholder="Nome" aria-label="Nome"/>
        </div>
        <div className='col-sm-12 my-2'>
          <span className='small text-muted d-block'><b>Cognome</b></span>
          <input name="cognome" value={formDataUpdateUserPending?.cognome || ''} onChange={handleFormChange} className="form-control" type="text" placeholder="Cognome" aria-label="Cognome"/>
        </div>
        <div className='col-sm-12 my-2'>
          <span className='small text-muted d-block'><b>Email</b></span>
          <input name="username" value={formDataUpdateUserPending?.username || ''} onChange={handleFormChange} className="form-control" type="text" placeholder="Email" aria-label="Email"/>
        </div>
        <div className='col-sm-12 my-2'>
          <span className='small text-muted d-block'><b>Agenzia</b></span>
          <select 
            name="id_agenzia" 
            value={formDataUpdateUserPending?.id_agenzia || ''} 
            onChange={handleFormChange} 
            className="form-control"
          >
            <option value="">Nessuna agenzia</option>
            {agenzie.map((agenzia) => (
              <option key={agenzia.id_agenzia} value={agenzia.id_agenzia}>
                {agenzia.denominazione}
              </option>
            ))}
          </select>
        </div>
        <div className='mt-4'>
             { loadingStateUtenti.isLoadingUtentiUpdate ? (
                  <Button variant="primary" disabled className="mx-1">
                  <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                        className="me-2"
                  />
                  Salva modifiche...
                  </Button>
                  ) : (
                  <Button type="button" variant='primary' onClick={onUpdateUserPending} className="mx-1">
                        Salva modifiche
                  </Button>
                  )}
               <button className='btn btn-secondary mx-1' onClick={onUndoChanges}>Annulla</button>
            </div>
  </div>
  )
}

export default UpdateUserPendingForm;